import { POLYGON_STATUS_LABELS } from '@forest/contracts';
import { useTranslation } from 'react-i18next';

const STATUS_STYLES: Record<string, { dot: string; text: string }> = {
  IN_POLYGON: { dot: 'bg-green-500 shadow-green-500/40', text: 'text-green-700' },
  AUTO_ADJUSTED: { dot: 'bg-yellow-500 shadow-yellow-500/40', text: 'text-yellow-700' },
  NOT_ASSIGNED: { dot: 'bg-red-500 shadow-red-500/40', text: 'text-red-700' },
  MANUAL_ADJUSTED: { dot: 'bg-orange-500 shadow-orange-500/40', text: 'text-orange-700' },
};

interface PolygonStatusBadgeProps {
  status: string;
}

export function PolygonStatusBadge({ status }: PolygonStatusBadgeProps) {
  const { i18n } = useTranslation();
  const lang = (i18n.language ?? 'ro') as 'ro' | 'ru' | 'en';
  const style = STATUS_STYLES[status] ?? { dot: 'bg-gray-400 shadow-gray-400/40', text: 'text-gray-600' };
  const label = POLYGON_STATUS_LABELS[status]?.[lang] ?? status;

  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${style.text}`}>
      <span
        className={`inline-block h-2 w-2 rounded-full shadow-sm ${style.dot}`}
      />
      {label}
    </span>
  );
}
